<div class="view-profile-menu">
  @if (state.guest?.email) {
    <button
      appButton
      name="logout"
      location="view-profile-menu"
      (click)="logout()"
      height="1"
      [iconButton]="true"
      color="simple-gray"
      class="logout-button"
    >
      <app-svg src="/assets/icons/logout.svg"></app-svg>
    </button>
  }
  <div class="avatar">
    <app-avatar [user]="state.user || state.guest"></app-avatar>

    <app-badge color="primary" [stroke]="true">
      @if (accessLevel === 'edit') {
        Editor
      }
      @if (accessLevel === 'review') {
        Reviewer
      }
      @if (accessLevel === 'view_only') {
        View-only
      }
    </app-badge>
  </div>
  @if (state.user) {
    <h2>{{ state.user.first_name }} {{ state.user.last_name }}</h2>
  }
  @if (state.guest) {
    <h2>{{ state.guest.name }}</h2>
  }
  @if (!state.guest && !state.user) {
    <h2>{{ anonymousGuestName }}</h2>
  }
  @if (state.user) {
    <p class="standard-text">
      {{ state.user.email }}
    </p>
  }
  @if (state.guest) {
    <p class="standard-text">
      {{ state.guest.email }}
    </p>
  }
  @if (state.user) {
    <div class="buttons">
      <a
        [href]="picflowUrl + '/a/settings/profile'"
        target="_blank"
        appButton
        name="your-account"
        location="view-profile-menu"
        spacing="full"
        color="primary"
        shape="round"
        class="manage-account-button"
      >
        <span>Manage Account</span>
      </a>
    </div>
  }
  @if (!state.user) {
    <div class="buttons">
      <button
        appButton
        name="update-guest-profile"
        data-test-id="update-guest-profile"
        location="view-profile-menu"
        icon="person-card"
        spacing="full"
        shape="round"
        weight="bold"
        color="primary"
        (click)="openGuestProfileDialog(); onClose.emit()"
      >
        <span>Update Your Info</span>
      </button>
      <a
        appButton
        [href]="getSignupUrl()"
        target="_blank"
        name="create-account"
        location="view-profile-menu"
        icon="person-card"
        shape="round"
        [center]="true"
        height="0"
        color="simple-primary"
      >
        <span>Create Full Account</span>
      </a>
      <!-- <app-button-menu-item name="manage-notifications" location="view-profile-menu" icon="bell" [fullWidth]="true">
      <span>Manage Notifications</span>
    </app-button-menu-item> -->
    </div>
  }
</div>
